const environment = process.env.NEXT_PUBLIC_CLAYTON_ENVIRONMENT;

/**
 * Each form endpoint will have a unique apiKey, and route.
 * Currently, Opening Doors is only on HBGCom and that component
 * derived from the shared libarary published by CB.
 */
const options = {
  contactus: {
    apiKey: '1kCk1GpLTD4nBXpvAmT5wXEuNomnDeCED1wXju7Kigt7spGBD8VT',
    url: {
      dev: 'https://forms-claytonbuilt.itg.cct-pubweb.com/contactus/v2',
      itg: 'https://forms-claytonbuilt.itg.cct-pubweb.com/contactus/v2',
      qua: 'https://forms-claytonbuilt.qua.cct-pubweb.com/contactus/v2',
      prod: 'https://forms.claytonbuilt.com/contactus/v2',
      localhost: 'https://forms-claytonbuilt.itg.cct-pubweb.com/contactus/v2',
    },
  },
  crossmod: {
    apiKey: '2SbfqRrFUP9eAdwYqSdWHlQjwE6JvMaBDm3GuyDuZQB7Hj1ApuxH',
    url: {
      dev: 'https://forms-claytonbuilt.itg.cct-pubweb.com/crossmod/v2',
      itg: 'https://forms-claytonbuilt.itg.cct-pubweb.com/crossmod/v2',
      qua: 'https://forms-claytonbuilt.qua.cct-pubweb.com/crossmod/v2',
      prod: 'https://forms.claytonbuilt.com/crossmod/v2',
      localhost: 'https://forms-claytonbuilt.itg.cct-pubweb.com/crossmod/v2',
    },
  },
  openingdoors: {
    apiKey: 'P1dQ9rrTXnYgdZP2zH1D564qrF1ESrQghCy2CJrqA3kwJs2dH3Av',
    url: {
      dev: 'https://forms-claytonhomebuildinggroup.itg.cct-pubweb.com/openingdoors/v2',
      itg: 'https://forms-claytonhomebuildinggroup.itg.cct-pubweb.com/openingdoors/v2',
      qua: 'https://forms-claytonhomebuildinggroup.qua.cct-pubweb.com/openingdoors/v2',
      prod: 'https://forms.claytonhomebuildinggroup.com/openingdoors/v2',
    },
  },
};

/**
 * When running on localhost, point to ITG.
 * The form service, which requires EventBridge, can't run on localhost.
 */
export const getEndpointDescription = (id: string) => {

  const info = options[id];
  if (!info) {
    return;
  }

  return {
    apiKey: info.apiKey,
    url: info.url[environment] || info.url['prod'],
  };
};
